import { render, staticRenderFns } from "./UploadComponent.vue?vue&type=template&id=680e4473&"
import script from "./UploadComponent.vue?vue&type=script&lang=js&"
export * from "./UploadComponent.vue?vue&type=script&lang=js&"
import style0 from "./UploadComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports